import React, { useState, useEffect } from 'react';
import teamService from '../../../services/teamService';
import './TaskCard.css';

const TaskCard = ({ selectedTeam, theme }) => {
  const [teamTask, setTeamTask] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (selectedTeam) {
      loadTeamTask();
    } else {
      setTeamTask('');
    }
  }, [selectedTeam]);

  const loadTeamTask = async () => {
    if (!selectedTeam) return;
    
    try {
      setLoading(true);
      setError(null);
      
      const teamData = await teamService.getTeam(selectedTeam);
      if (teamData && teamData.description) {
        setTeamTask(teamData.description);
      } else {
        setTeamTask('');
      }
    } catch (error) {
      console.error('Ошибка загрузки задания команды:', error);
      setError('Не удалось загрузить задание команды');
      setTeamTask('');
    } finally {
      setLoading(false);
    }
  };

  if (!selectedTeam) {
    return null;
  }

  return (
    <div className={`task-card ${theme === 'dark' ? 'dark-theme' : ''}`}>
      <div className="task-card-header">
        <h3>📋 Задание команды</h3>
        <span className="team-name">{selectedTeam}</span>
      </div>
      
      <div className="task-card-content">
        {loading ? (
          <div className="task-loading">
            <span>Загрузка задания...</span>
          </div>
        ) : error ? (
          <div className="task-error">
            <span>⚠️ {error}</span>
          </div>
        ) : teamTask ? (
          <div className="task-text">
            {teamTask}
          </div>
        ) : (
          <div className="task-empty">
            <span>Задание не задано</span>
            <small>Обратитесь к администратору для установки задания</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskCard;
